/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Shop/AccountBalance': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M20 17.887h7v-4.069h-7v4.07zM22.773 4.02l1.029 3.186H13.238l9.535-3.186zm-3.456-2.223l1.101 1.94-10.21 3.41 9.109-5.35zm8.433 11.005H27v-2.544a3.038 3.038 0 00-2.095-2.895L23.49 2.977a.249.249 0 00-.315-.162l-1.787.597-1.58-2.785a.25.25 0 00-.342-.093L8.109 7.205H8c-1.657 0-3 1.367-3 3.052v11.191C5 23.134 6.343 24.5 8 24.5h16c1.657 0 3-1.366 3-3.052v-1.272a.252.252 0 00-.25-.254h-1.5a.252.252 0 00-.25.254v1.272c0 .562-.447 1.017-1 1.017H8c-.552 0-1-.455-1-1.017v-11.19A1.01 1.01 0 018 9.24h16c.553 0 1 .456 1 1.017v2.544h-5.75a.252.252 0 00-.25.254v5.595c0 .14.112.255.25.255h8.5c.138 0 .25-.114.25-.255v-5.595a.252.252 0 00-.25-.254zM22 16.87c.553 0 1-.456 1-1.017 0-.563-.447-1.018-1-1.018-.553 0-1 .455-1 1.018 0 .561.447 1.017 1 1.017"/>'
  }
})
